module.exports = "/dist/poster-0619671f729852d7f5cca34304bc7dcc.png";